module.exports = __webpack_public_path__ + "images/icons_v2/packaging-7f9c259e.svg";